import gql from 'graphql-tag';
import FieldsTimeslotGroup from "graphql/fields/FieldsTimeslotGroup";

export default gql(`
	query timeslot_group( $guid: String! ) {
		timeslot_group( guid: $guid ) {
			${FieldsTimeslotGroup}
		}
	}
`);